<template>
	<div class="row">
		<div
			v-for="(colData, colDataIndex) in $parent.data.results"
			:key="colDataIndex"
			class="col-12 col-sm-6 col-xl-4 col-xxl-3"
		>
			<slot
				name="_mobile"
				v-bind="colData"
				class="card"
				:class="$style.card"
			>
				<div class="card-body py-0">
					<div
						v-for="(col, colIndex) in $parent.cols"
						:key="colIndex"
						class="row"
						:class="[$style.cardRow, $style[`card${col.slot}`]]"
					>
						<div
							class="col-6"
							:class="$style.cardCol"
						>
							<h5 :class="$style.cardTitle">
								{{ col.title || col.index || '???' }}
							</h5>
						</div>

						<div
							:class="$style.cardCol"
							class="col-6"
						>
							<slot
								v-if="col.slot!==undefined"
								:name="col.slot"
								v-bind="colData"
							>
								{{ colData[col.index] }}
							</slot>

							<div v-else>
								{{ colData[col.index] }}
							</div>
						</div>
					</div>
				</div>
			</slot>
		</div>
	</div>
</template>

<script>
export default {

};
</script>

<style lang="scss" module>
	.card {
		.cardRow:nth-child(even){
			position: relative;
		}

		.cardRow:nth-child(even)::before{
			width: 100%;
			height: 100%;
			display: block;
			content: ' ';
			z-index: 0;
			position: absolute;
			left: 0;
			top: 0;
			background-color: $dark-gray-4;
		}

		.cardRow{
			display: flex;
			align-items: center;
			padding: 10px;

			.cardCol{
				position: relative;
				z-index: 1;
			}
		}

		.cardRow.card_actions, .cardRow.card_actionsMobile{
			padding: 10px 0;
		}

		.cardTitle{
			font-size: 1.2em;
			margin-bottom: 0;
		}
	}
</style>
